import FormFieldLabel from './FormFieldLabel.component';

export default FormFieldLabel;